import { Box } from 'components/widgets/Box'
import { Image } from 'components/widgets/Image'
import { IS_WEB } from 'constants/platform'
import { useTheme } from 'contexts'
import React, { useEffect, useState } from 'react'
import { StyleSheet, TextInput } from 'react-native'

import { CreatorInfo } from 'partials/CreatorInfo/CreatorInfo'

import { useMaxWidth } from 'hooks/useMaxWidth'

import { defaultPostThumbnailUrl } from 'utils/media'
import commonStyles from 'utils/styles/commonStyles'

import { Program } from 'types/program'

type HeaderProps = {
  program?: Program
  onChange?: (title: string, description: string) => void
}

export const Header = ({ program, onChange }: HeaderProps) => {
  const theme = useTheme()
  const { width: maxWidth } = useMaxWidth()

  const programCover = (IS_WEB ? program?.cover?.url : program?.cover) ?? defaultPostThumbnailUrl

  const [title, setTitle] = useState<string>(program?.title ?? '')
  const [description, setDescription] = useState<string>(program?.description ?? '')

  const [titleHeight, setTitleHeight] = useState<number>(40)
  const [titleActive, setTitleActive] = useState<boolean>(false)

  const [descHeight, setDescHeight] = useState<number>(20)
  const [descActive, setDescActive] = useState<boolean>(false)

  const styles = StyleSheet.create({
    textInput: {
      paddingLeft: 0,
      paddingTop: 0,
      paddingRight: 0,
      paddingBottom: 0,
      outlineStyle: 'none',
      backgroundColor: theme.colors.white,
      borderColor: theme.colors.transparent,
      placeholderTextColor: theme.colors.v2lightGrey,
    },
    titleInput: {
      maxHeight: 80,
      height: titleHeight,
      fontSize: theme.spacing.xl,
      fontWeight: '700',
      color: titleActive ? theme.colors.black : theme.colors.grey,
    },
    descriptionInput: {
      height: descHeight,
      fontSize: theme.spacing.md,
      color: descActive ? theme.colors.black : theme.colors.grey,
    },
  })

  useEffect(() => {
    onChange && onChange(title.trim(), description.trim())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title, description])

  return (
    <>
      <Box
        testID='CoverTitleContainer'
        width='100%'
        flexDirection='row'
        padding={{ vertical: 'md' }}
      >
        <Box
          shadow='sm'
          width={maxWidth * 0.38}
          height={maxWidth * 0.38}
          testID='ProgramCoverContainer'
          backgroundColor='v2lightGrey'
          borderRadius='sm'
          style={commonStyles.overflowHidden}
        >
          <Image style={commonStyles.fullSize} resizeMode='cover' source={programCover} />
        </Box>

        <Box
          testID='ProgramTitleContainer'
          flex={1}
          margin={{ left: 'md' }}
          justifyContent='center'
        >
          <TextInput
            editable
            multiline
            value={title}
            placeholder='Title'
            onChangeText={setTitle}
            style={{ ...styles.textInput, ...styles.titleInput }}
            onContentSizeChange={(event) => {
              const newHeight = event.nativeEvent.contentSize.height
              newHeight < 100 && setTitleHeight(newHeight)
            }}
            onFocus={() => setTitleActive(true)}
            onBlur={() => setTitleActive(false)}
          />

          <CreatorInfo creatorId={program?.trainer?.id} />
        </Box>
      </Box>

      <Box testID='ProgramDescriptionContainer'>
        <TextInput
          editable
          multiline
          value={description}
          scrollEnabled={false}
          placeholder='Program description...'
          onChangeText={setDescription}
          style={{ ...styles.textInput, ...styles.descriptionInput }}
          onContentSizeChange={(event) => setDescHeight(event.nativeEvent.contentSize.height)}
          onFocus={() => setDescActive(true)}
          onBlur={() => setDescActive(false)}
        />
      </Box>
    </>
  )
}
